export default __webpack_public_path__ + "static/home_inventory-70107e87ceef67b4c59bbfd6432ce268.jpg";